import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export function deleteLocation(id: number) {
  return fetchWrapper({
    url: `/api/location/${id}`,
    fetchArg: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });
}
